<template>
  <div class="well page" v-if="job">
    <div id="printReview" class="row">
      <h2>Submitted Request</h2>
      <div id="showMsg"><!-- Error messages etc are shown here --></div>

      <img class="floorplan-img" :src="'/dashboard/jobs/image/' + job.id + '/'"/>

      <p>This report documents the issues outlined below for your <b>{{ store.name }}</b> store.</p>
      <b v-if="job.urgent">You have chosen to have this request completed ASAP!</b>
      <p v-if="!job.urgent">You have chosen to have this request completed in <b>{{ job.urgency_days }}</b> days.</p>

      <h3 v-if="issues.length > 0 ">Request Summary</h3>
      <div class="col-xs-12" v-for="issue in issues">
        <div class="panel panel-default">
          <div class="panel-body">
            <b>Type: {{ issue_type_name(issue.type) }}</b> <br>
            <i class="description">Description: {{ issue.description }}</i> <br>
            <div
                v-for="image in issue_images(issue)"
                style="display: inline;"
            >
              <i
                  class="glyphicon glyphicon-picture"
                  @click="view_image(image)"
                  style="cursor: pointer"
              ></i>&nbsp;
            </div>
            <br v-if="!issue_images(issue).length">
          </div>
        </div>
      </div>
    </div>
      <modal
          v-if="selected_photo"
          v-model="modal_open"
          title="View Issue Image"
          @hide="modal_closed"
          size="lg"
      >
      <img :src="selected_photo.image">
    </modal>
  </div>
</template>

<style scoped>
  img {
    max-width: 100%;
  }

  img.floorplan-img {
    width: 800px;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  
  i.description {
    white-space: pre-line;
  }
</style>

<script>
  import {Modal} from "uiv"

  import {mapGetters} from "vuex"
  import {find, filter} from "lodash"

  export default {
    data () {
      return {
        selected_photo: null,
        modal_open: false,
      }
    },
    async created () {
      let promises = [
        this.$store.dispatch("get_jobs", {job_id: this.$route.params.job_id, lazy: true}),
        this.$store.dispatch("get_issues", {job_id: this.$route.params.job_id}),
        this.$store.dispatch("get_issue_photos", {job_id: this.$route.params.job_id}),
        this.$store.dispatch("get_stores", true)
      ];
      await Promise.all(promises);
      this.$store.commit("select_job", this.$route.params.job_id);
      this.$store.commit("select_store", this.job.store);
    },
    computed: mapGetters([
      "job",
      "store",
      "issues",
      "issue_types",
      "issue_photos",
    ]),
    methods: {
      issue_type_name (type) {
        let it = find(this.issue_types, {id: type});
        if (!it) {
          return "Unknown Issue Type"
        }
        return it.name;
      },
      issue_images (issue) {
        return filter(this.issue_photos, {issue: issue.id});
      },
      view_image (photo) {
        this.selected_photo = photo;
        this.modal_open = true;
      },
      modal_closed () {
        this.selected_photo = null;
      },
    },
    components: {
      Modal,
    },
  }
</script>



// WEBPACK FOOTER //
// assets/vue/logger/JobPost.vue?e5f13728